'use client'

import { Button, toast, useDocumentInfo } from '@payloadcms/ui'
import React, { useState } from 'react'

const RefetchMaterialsButton: React.FC = () => {
  const { id } = useDocumentInfo()
  const [isLoading, setIsLoading] = useState(false)

  const handleRefetch = async () => {
    if (!id) {
      toast.error('No skill tree ID available')
      return
    }

    setIsLoading(true)

    const refetchPromise = fetch(`/api/skill-trees/${id}/refetch-materials`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (response) => {
        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.error || data.details || 'Failed to queue material refresh')
        }

        return data
      })
      .finally(() => {
        setIsLoading(false)
      })

    toast.promise(refetchPromise, {
      loading: 'Queueing material refresh jobs...',
      success: (data) => {
        return `Successfully queued ${data.queuedCount} material(s) for refresh. Jobs will be processed in the background.`
      },
      error: (err) => {
        const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred'
        return `Failed to queue refresh: ${errorMessage}`
      },
    })
  }

  return (
    <div className="">
      <div className="mb-4">
        <h3 className="text-xl font-semibold mb-2">Refetch Notion Materials</h3>
        <p className="text-base text-[var(--theme-elevation-600)] mb-3">
          Queue background jobs to refresh all Notion materials in this skill tree.
          <br />
          Jobs will be processed automatically and content will be updated in the background.
        </p>
        <Button onClick={handleRefetch} buttonStyle="secondary" size="large" disabled={isLoading}>
          {isLoading ? 'Queueing Jobs...' : 'Refetch Materials'}
        </Button>
      </div>
    </div>
  )
}

export default RefetchMaterialsButton
